// import styled from "@emotion/styled";
import { styled } from "@mui/material/styles";
import { Button, ButtonBase, ButtonProps, Menu, MenuItem } from "@mui/material";
import EditIcon from "./../../assets/images/icons/edit.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { height, minWidth } from "@mui/system";
import { ReactNode } from "react";
interface CustomIconButtonProps extends ButtonProps {
  isTransparent?: boolean;
  bgColor?: string; // optional custom background color prop
  textColor?: string;
}
interface OutlinedPrimaryButtonProps extends ButtonProps {
  width?: string | number;
  height?: string | number;
  border?: string;
  borderRadius?: string | number;
  textColor?: string; // renamed from 'color' to avoid conflict
  backgroundColor?: string;
  children?: ReactNode;
}
interface UploadButtonProps extends ButtonProps {
  customHeight?: string | number;
}
export const SmallButton = ({ click, title }: any) => {
  return (
    <Button
      variant="outlined"
      size="large"
      onClick={() => click()}
      sx={{
        height: "35px",
        textTransform: "none",
        color: "white",
        letterSpacing: "0.43px",
        fontSize: "14px",
        fontWeight: "600",
        border: "2px solid rgba(0, 179, 181, 1)",
        borderRadius: "6px",
        backgroundColor: "rgba(0, 179, 181, 1)",
        boxShadow: "0px 2px 4px 0px rgba(165, 163, 174, 0.3)",
        minWidth: { xs: "70px", sm: "114px", md: "105px", lg: "120px" },
        "&:hover": {
          backgroundColor: "rgba(0, 179, 181, 1)", // Keep the same background on hover
          border: "2px solid rgba(0, 179, 181, 1)",
        },
      }}
    >
      {title}
    </Button>
  );
};

export const OutlinedSmallButton = ({
  click,
  title,
  iconPosition,
  icon,
  width,
  disabled
}: any) => {
  return (
    <Button
      variant="outlined"
      size="large"
      onClick={() => click()}
      disabled={disabled ? disabled : false}
      sx={{
        width: width,
        height: "32px",
        textTransform: "none",
        color: "rgba(0, 179, 181, 1)",
        letterSpacing: "0.43px",
        fontSize: "13px",
        fontWeight: "600",
        border: "1px solid rgba(0, 179, 181, 1)",
        borderRadius: "4px",
        "&:hover": {
          border: "1px solid rgba(0, 179, 181, 1)",
        },
         minWidth: { xs: "70px", sm: "114px", md: "125px", lg: "125px" },
      }}
    >
      {iconPosition == "left" && icon}
      &nbsp;
      {title}
      &nbsp;
      {iconPosition == "right" && icon}
    </Button>
  );
};
export const DropdownButton = ({ click, title }: any) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end", // Aligns the button to the right
        marginTop: "-42px",
        marginBottom: "5px",
      }}
    >
      <Button
        variant="outlined"
        onClick={(event) => click(event)}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          height: "35px",
          textTransform: "none",
          color: "rgba(0, 179, 181, 1)",
          letterSpacing: "0.43px",
          fontSize: "13px",
          fontWeight: "600",
          border: "1px solid rgba(0, 179, 181, 1)",
          borderRadius: "4px",
          "&:hover": {
            border: "1px solid rgba(0, 179, 181, 1)",
          },
        }}
      >
        LAN VIZEE00065992
      </Button>
    </div>
  );
};

export const PrimaryButton = styled(
  ({ width, height, fontSize, ...props }: any) => (
    <Button variant="contained" {...props} />
  )
)(({ theme, width, height, fontSize, ...props }) => ({
  "&.MuiButtonBase-root": {
    height: height || "39px",
    width: width,
    gap: "0px",
    borderRadius: "6px",
    textTransform: "capitalize",
    background: "rgba(0, 179, 181, 1)",
    fontWeight: "400",
    fontSize: fontSize || "15px",
    color: "#ffffff",
    boxShadow: `0px 2px 4px rgba(165, 163, 174, 0.3)`,
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));
export const PrimaryButtonSecond = styled(
  ({ width, height, fontSize, ...props }: any) => (
    <Button variant="contained" {...props} />
  )
)(({ theme, width, height, fontSize, ...props }) => ({
  "&.MuiButtonBase-root": {
    height: height || "39px",
    width: width,
    gap: "0px",
    borderRadius: "6px",
    textTransform: "capitalize",
    background: "#ffcc02",
    color: "#000000",
    fontWeight: "400",
    fontSize: fontSize || "15px",
    boxShadow: `0px 2px 4px rgba(165, 163, 174, 0.3)`,
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));
export const OutlinedPrimaryButton = styled(
  ({
    width,
    height,
    border,
    borderRadius,
    textColor,
    backgroundColor,
    children,
    ...props
  }: OutlinedPrimaryButtonProps) => <Button {...props}>{children}</Button>
)(
  ({
    width,
    height,
    border,
    borderRadius,
    textColor,
    backgroundColor,
    disabled,
  }) => ({
    width: width ?? "auto",
    height: height ?? "39px",
    gap: "5px",
    borderRadius: borderRadius ?? "4px",
    textTransform: "capitalize",
    backgroundColor: backgroundColor ?? "transparent", // use backgroundColor prop here
    fontWeight: 600,
    fontSize: "13px",
    boxShadow: "none",
    color: textColor ?? "rgba(0, 179, 181, 1)",
    border: disabled ? "none" : border ?? "1px solid rgba(0, 179, 181, 1)",
    "&.Mui-disabled": {
      backgroundColor: "#E6E6E6",
      color: "#B3B3B3",
    },

    // Active state styles
    "&.Mui-active": {
      borderColor: "#00b3b5",
      color: "#00b3b5",
      fontWeight: 600,
    },

    // Optional: focus visible for keyboard accessibility
    "&.Mui-focusVisible": {
      borderColor: "#00b3b5",
      color: "#00b3b5",
      fontWeight: 600,
    },
  })
);

export const OutlinedSecondaryButton = styled(
  ({ width, height, ...props }: any) => (
    <Button variant="contained" {...props} />
  )
)(({ theme, width, height, ...props }) => ({
  "&.MuiButtonBase-root": {
    width: width,
    height: height || "39px",
    gap: "5px",
    borderRadius: "4px",
    textTransform: "capitalize",
    background: "#FDBF1D",
    fontWeight: "600",
    fontSize: "13px",
    boxShadow: "none",
    color: "white",
    // border: props?.disabled ? "none" : "1px solid #FDBF1D",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));

export const SecondaryButton = styled((props: any) => (
  <Button variant="contained" {...props} />
))(({ theme }) => ({
  "&.MuiButtonBase-root": {
    minHeight: "44px",
    textTransform: "capitalize",
    borderRadius: "6px",
    background: "#FFF2CC",
    fontWeight: "700",
    fontSize: "15px",
    boxShadow: "none",
    color: "#0A0A0A",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));

export const EditSecondaryButton = styled(
  ({ width, height, ...props }: any) => (
    <Button variant="contained" {...props} />
  )
)(({ theme, width, height, ...prop }) => ({
  "&.MuiButtonBase-root": {
    width: width,
    minHeight: height || "44px",
    textTransform: "capitalize",
    borderRadius: "8px",
    background: "#A8AAAE",
    fontWeight: "600",
    fontSize: "15px",
    boxShadow: "0px 2px 4px rgba(165, 163, 174, 0.3)",
    color: "white",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));

export const PrimaryButtonText = styled((props: any) => (
  <Button variant="text" {...props} />
))(({ theme }) => ({
  "&.MuiButtonBase-root": {
    textTransform: "capitalize",
    fontWeight: "500",
    borderRadius: "8px",
    size: "16px",
    color: "#1CB1B1",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    color: "#B3B3B3",
  },
}));

export const SecondaryButtonText = styled(({ height, marginTop, ...props }: any) => (
  <Button variant="text" {...props} />
))(({ height, marginTop }) => ({
  "&.MuiButtonBase-root": {
    textTransform: "capitalize",
    fontWeight: "500",
    borderRadius: "8px",
    fontSize: "16px",
    color: "#00B3B5",
    ...(height && { height }),
    ...(marginTop && { marginTop }),
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    color: "#B3B3B3",
  },
}));

export const HeaderButton = styled((props: any) => (
  <Button variant="text" {...props} />
))(({ theme }) => ({
  "&.MuiButtonBase-root": {
    textTransform: "capitalize",
    borderRadius: "50px",
    background: "#FFFFFF",
    fontWeight: "600",
    fontSize: "16px",
    boxShadow: "none",
    color: "#12B76A",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    color: "#B3B3B3",
  },
}));

export const PicUploadButton = styled((props: any) => (
  <ButtonBase {...props}>
    <img src={EditIcon} alt="edit-icon" />
  </ButtonBase>
))(({ theme }) => ({
  "&.MuiButtonBase-root": {
    borderRadius: "50%",
  },
}));

export const UploadButton = styled((props: UploadButtonProps) => {
  const { customHeight, ...rest } = props;
  return <Button variant="text" {...rest} />;
})<UploadButtonProps>(({ customHeight }) => ({
  "&.MuiButtonBase-root": {
    width: "max-content",
    height: customHeight ?? "28px",
    gap: "0px",
    borderRadius: "6px",
    textTransform: "capitalize",
    background: "transparent",
    fontWeight: "600",
    fontSize: "12px",
    boxShadow: "none",
    color: "rgba(0, 179, 181, 1)",
    border: "1px solid rgba(0, 179, 181, 1)",
    padding: "6px 14px",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
  },
}));

export const ErrorButton = styled((props: any) => (
  <Button variant="contained" {...props} />
))(({ theme }) => ({
  "&.MuiButtonBase-root": {
    minHeight: "40px",
    textTransform: "capitalize",
    borderRadius: "8px",
    background: "#E12E2E",
    fontWeight: "600",
    fontSize: "12px",
    boxShadow: "none",
    color: "#FFFFFF",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E12E2E",
    color: "#FFFFFF",
  },
}));

export const IconButton = styled(
  ({ isTransparent, bgColor, textColor, ...props }: CustomIconButtonProps) => (
    <Button variant="contained" {...props} />
  )
)(
  ({
    theme,
    isTransparent,
    bgColor,
    textColor,
  }: {
    theme: any;
    isTransparent?: boolean;
    bgColor?: string;
    textColor?: string;
  }) => ({
    width: "auto",
    height: 38,
    gap: 8,
    borderRadius: 6,
    paddingTop: 2,
    paddingRight: 16,
    paddingBottom: 2,
    paddingLeft: 16,
    fontFamily: "Jost, sans-serif",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "100%",
    letterSpacing: "0%",
    color: textColor || "#1F2233", // default text color
    background: isTransparent ? "none" : bgColor || "#fecd3d", // default background color
    textTransform: "none",
    boxShadow: "none",

    "&.MuiButton-root.Mui-disabled": {
      background: "#9E9E9E",
    },
    "&:hover": {
      width: "auto",
      gap: 8,
      borderRadius: 6,
      paddingTop: 2,
      paddingRight: 16,
      paddingBottom: 2,
      paddingLeft: 16,
      fontFamily: "Jost, sans-serif",
      fontWeight: 600,
      fontSize: 12,
      lineHeight: "100%",
      letterSpacing: "0%",
      color: textColor || "#1F2233", // default text color
      background: isTransparent ? "none" : bgColor || "#fecd3d", // default background color
      textTransform: "none",
      boxShadow: "none",
    },
  })
);

export const DashboardOutlinedButton = styled(
  ({ width, height, ...props }: any) => (
    <Button variant="outlined" {...props} />
  )
)(({ width, height }: any) => ({
  "&.MuiButtonBase-root": {
    width: width ?? "auto",
    height: height ?? "39px",
    gap: "0px",
    borderRadius: "6px",
    textTransform: "capitalize",
    background: "transparent",
    fontWeight: "600",
    fontSize: "15px",
    boxShadow: "none",
    color: "#333333",
    border: "1.5px solid #333333",
  },
  "&.MuiButtonBase-root:hover": {
    background: "#f5f5f5",
    borderColor: "#333333",
  },
  "&.MuiButtonBase-root.Mui-disabled": {
    background: "#E6E6E6",
    color: "#B3B3B3",
    borderColor: "#B3B3B3",
  },
}));
